import { DefaultUrlSerializer, UrlTree } from '@angular/router';

  export class CustomUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    const decodedUrl = url.replace(/%3F/g, '?');
    return super.parse(decodedUrl);
  }
}